document.addEventListener('DOMContentLoaded', function () {

    const morse_converter = {
        'a': '.- ', 'b': '-... ', 'c': '-.-. ', 'd': '-.. ', 'e': '. ',
        'f': '..-. ', 'g': '--. ', 'h': '.... ', 'i': '.. ', 'j': '.--- ',
        'k': '-.- ', 'l': '.-.. ', 'm': '-- ', 'n': '-. ', 'o': '--- ',
        'p': '.--. ', 'q': '--.- ', 'r': '.-. ', 's': '... ', 't': '- ',
        'u': '..- ', 'v': '...- ', 'w': '.-- ', 'x': '-..- ', 'y': '-.-- ',
        'z': '--.. ', '1': '.---- ', '2': '..--- ', '3': '...-- ', '4': '....- ',
        '5': '..... ', '6': '-.... ', '7': '--... ', '8': '---.. ', '9': '----. ',
        '0': '----- ', '.': '.-.-.- ', ',': '--..-- ', '?': '..--.. ',
        "'": '.----. ', '!': '-.-.-- ', '/': '-..-. ', '(': '-.--. ',
        ')': '-.--.- ', '&': '.-... ', ':': '---... ', ';': '-.-.-. ',
        '=': '-...- ', '+': '.-.-. ', '-': '-....- ', '_': '..--.- ',
        '"': '.-..-. ', '$': '...-..- ', '@': '.--.-. ', ' ': '/'
    };

    let engravingType = null;
    let engravingFont = null;
    let parentVariantId = null;

    const variantPopup    = document.querySelector('.variant-popup-customization');
    const popupButton     = document.querySelector('.product-popup-button-wrapper button');
    const closeBtn        = document.querySelector('.variant-popup-header .close-btn');
    const goBackBtn       = document.querySelector('.variant-popup-header .go-back-btn');
    const morseCodeInput  = document.querySelector('#morse-code-engraving-input');
    const morseCodeTransl = document.querySelector('#morse-code-translation');
    const rotatingSpan    = document.querySelector('.popular-engravings span');

    const rotatingCopy = [
        "our initials (JFK)",
        "The date you met (03.03.2003)",
        "Children's names (Sarah)",
        "Your nickname for each other (Peanut)",
        "My ♡ is yours",
        "You complete me"
    ];
    let rotatingInterval = null;

    // ── Morse live translation ───────────────────────────────────
    if (morseCodeInput && morseCodeTransl) {
        morseCodeInput.addEventListener('keyup', function () {
            let out = '';
            for (let i = 0; i < morseCodeInput.value.length; i++) {
                const ch = morseCodeInput.value.charAt(i).toLowerCase();
                out += morse_converter[ch] || '';
            }
            morseCodeTransl.value = out;
        });
    }

    // ── Rotating copy ────────────────────────────────────────────
    function startRotatingCopy() {
        if (!rotatingSpan) return;
        let idx = 0;
        rotatingSpan.textContent = rotatingCopy[0];
        if (rotatingInterval) clearInterval(rotatingInterval);
        rotatingInterval = setInterval(function () {
            idx = (idx + 1) % rotatingCopy.length;
            rotatingSpan.textContent = rotatingCopy[idx];
        }, 2000);
    }

    // ── Helpers ──────────────────────────────────────────────────
    function removeActiveClass(selector) {
        document.querySelectorAll(selector).forEach(el => el.classList.remove('active'));
    }

    function handleStepCount(currentStep, totalStep) {
        const cur = document.querySelector('.variant-popup-header .current-step');
        const tot = document.querySelector('.variant-popup-header .total-steps');
        if (cur) cur.textContent = currentStep;
        if (tot && totalStep) tot.textContent = totalStep;
    }

    function resetPopup() {
        if (variantPopup) variantPopup.classList.remove('active');
        document.body.style.overflow = 'unset';
        removeActiveClass('.variant-popup-body-item');
        const first = document.querySelectorAll('.variant-popup-body-item')[0];
        if (first) first.classList.add('active');
        handleStepCount(1);
        if (rotatingInterval) clearInterval(rotatingInterval);
    }

    // ── Apply UI for chosen engraving type ───────────────────────
    function applyEngravingTypeUI(type) {
        const fontWrapper  = document.querySelector('.engraving-font-item-wrapper');
        const imageWrapper = document.querySelector('.add-engraving-wrapper .image-wrapper');
        const title        = document.querySelector('[data-type="add-engraving"] h2');

        if (fontWrapper)  fontWrapper.style.display  = (type === 'Morse Code')   ? 'none'  : 'block';
        if (imageWrapper) imageWrapper.style.display = (type === 'Coordinates')  ? 'none'  : 'block';

        if (title) {
            if (type === 'Coordinates') {
                title.textContent = "Which coordinates and font would you like to place on the pieces?";
            } else if (type === 'Morse Code') {
                title.textContent = "What text would you like to place on the pieces?";
            } else {
                title.textContent = "What text and font would you like to place on the pieces?";
            }
        }
    }

    // ── Auto-select first option in every group ──────────────────
    // KEY FIX: ensures buildVariantTitle() always has values before
    // the user manually clicks anything.
    function autoSelectDefaults() {
        document.querySelectorAll(
            '.select-product-finish-wrapper, .select-product-engraving-wrapper'
        ).forEach(wrapper => {
            if (!wrapper.querySelector('.product-option-block.active')) {
                const first = wrapper.querySelector('.product-option-block');
                if (first) first.classList.add('active');
            }
        });
    }

    // ── Build variant title from active option blocks ─────────────
    // FIX: removed .toUpperCase() — Shopify stores titles in their
    // original casing (e.g. "Gold / YES"), so we must match exactly.
    function buildVariantTitle() {
        const parts = [];

        document.querySelectorAll(
            '.select-product-finish-wrapper, .select-product-engraving-wrapper'
        ).forEach(wrapper => {
            const active = wrapper.querySelector('.product-option-block.active');
            if (active && active.dataset.value) {
                parts.push(active.dataset.value);
            }
        });

        return parts.join(' / ');
    }

    // ── Fetch variant details and update button ──────────────────
    function fetchVariantDetails(variantTitle) {
        const addBtn = document.querySelector('.select-stone-add-btn button');
        if (!addBtn) return false;

        console.log('[Popup] Looking up variant:', JSON.stringify(variantTitle));

        const variantEl = document.querySelector(
            `.hidden-variant-item[data-variant-title="${variantTitle}"]`
        );

        if (!variantEl) {
            console.warn('[Popup] No variant matched for title:', variantTitle);
            // Debug: log all available titles to help diagnose mismatches
            document.querySelectorAll('.hidden-variant-item').forEach(el => {
                console.log('[Popup] Available:', JSON.stringify(el.dataset.variantTitle));
            });
            addBtn.textContent = 'Unavailable';
            addBtn.setAttribute('disabled', true);
            parentVariantId = null;
            return false;
        }

        parentVariantId = variantEl.dataset.variantId;
        const available = variantEl.dataset.variantAvailable === 'true';
        const price     = variantEl.dataset.variantPrice;

        console.log('[Popup] Matched:', parentVariantId, available, price);

        // Optional variant image swap
        const variantImagesEl = document.querySelector('[data-variant-images-json]');
        if (variantImagesEl) {
            try {
                const { variant_images } = JSON.parse(variantImagesEl.innerHTML);
                if (variant_images && variant_images[parentVariantId]) {
                    const imgEl = document.querySelector('.select-finish-blocks img');
                    if (imgEl) imgEl.src = variant_images[parentVariantId];
                }
            } catch (e) {
                console.error('[Popup] variant images parse error:', e);
            }
        }

        if (available) {
            addBtn.innerHTML = 'Add to cart -&nbsp;' + price;
            addBtn.removeAttribute('disabled');
        } else {
            addBtn.textContent = 'Sold Out';
            addBtn.setAttribute('disabled', true);
        }

        return true;
    }

    function handleVariantChange() {
        const title = buildVariantTitle();
        fetchVariantDetails(title);
    }

    // ── Add to Cart ──────────────────────────────────────────────
    function handleAddToCart() {
        if (!parentVariantId) {
            console.error('[Popup] parentVariantId is null — no variant selected');
            alert('Please select an option before adding to cart.');
            return;
        }

        const data = {
            quantity: 1,
            id: parseInt(parentVariantId, 10),  // FIX: Shopify needs a number, not a string
            properties: {
                "Select engraving type:": engravingType
            }
        };

        if (engravingType === 'Morse Code') {
            const val = morseCodeInput ? morseCodeInput.value.trim() : '';
            if (val) data.properties["Morse Code"] = val;
        }
        if (engravingType === 'Coordinates') {
            data.properties["Select Engraving Font"] = engravingFont;
            const lat = document.querySelector('#coordinates-latitude');
            const lng = document.querySelector('#coordinates-longitude');
            if (lat && lat.value.trim()) data.properties["Latitude"]  = lat.value.trim();
            if (lng && lng.value.trim()) data.properties["Longitude"] = lng.value.trim();
        }
        if (engravingType === 'Text') {
            data.properties["Select Engraving Font"] = engravingFont;
            const textEl = document.querySelector('#text-engraving-input');
            if (textEl && textEl.value.trim()) data.properties["Engrave text"] = textEl.value.trim();
        }

        console.log('[Popup] Cart payload:', { items: [data] });

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [data] })
        })
        .then(r => r.json())
        .then(res => {
            console.log('[Popup] Cart response:', res);
            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: { quantity: 1 }
            }));
            resetPopup();
        })
        .catch(err => console.error('[Popup] Cart error:', err));
    }

    // ── Open popup ───────────────────────────────────────────────
    if (popupButton) {
        popupButton.addEventListener('click', function () {
            // Null-safe switcher lookup
            const activeSwitcher =
                document.querySelector('.custom_2x_cuff_bracelet .custom-switcher-btn.active-switcher') ||
                document.querySelector('.custom-switcher-btn.active-switcher') ||
                document.querySelector('.custom-switcher-btn');

            engravingType = (activeSwitcher && activeSwitcher.dataset.type) ? activeSwitcher.dataset.type : 'Text';

            applyEngravingTypeUI(engravingType);
            removeActiveClass('.add-engraving-input-container');
            const container = document.querySelector(`[data-engraving-type="${engravingType}"]`);
            if (container) container.classList.add('active');

            if (variantPopup) variantPopup.classList.add('active');
            document.body.style.overflow = 'hidden';

            startRotatingCopy();

            // FIX: auto-select defaults so variant lookup works immediately
            autoSelectDefaults();
            handleVariantChange();
        });
    }

    // ── Close ────────────────────────────────────────────────────
    if (closeBtn) {
        closeBtn.addEventListener('click', resetPopup);
    }

    // ── Go back ──────────────────────────────────────────────────
    if (goBackBtn) {
        goBackBtn.addEventListener('click', function () {
            const activeItem = document.querySelector('.variant-popup-body-item.active');
            if (!activeItem) return;
            const currentStep = parseInt(activeItem.dataset.currentStep);

            if (currentStep === 1) {
                resetPopup();
            } else {
                activeItem.classList.remove('active');
                const prevStep = (engravingType === 'Morse Code' && currentStep === 4)
                    ? currentStep - 2
                    : currentStep - 1;
                const prevItem = document.querySelector(`[data-current-step="${prevStep}"]`);
                if (prevItem) prevItem.classList.add('active');
                handleStepCount(prevStep);
            }
        });
    }

    // ── Per-step wiring ──────────────────────────────────────────
    function handleEngravingType(selector) {
        selector.querySelectorAll('.engraving-type-item-block').forEach(block => {
            block.addEventListener('click', function () {
                const currentStep = parseInt(selector.dataset.currentStep);
                engravingType = block.dataset.type;

                removeActiveClass('.engraving-type-item-block');
                block.classList.add('active');
                selector.classList.remove('active');

                const next = document.querySelector(`[data-current-step="${currentStep + 1}"]`);
                if (next) next.classList.add('active');

                removeActiveClass('.add-engraving-input-container');
                const container = document.querySelector(`[data-engraving-type="${engravingType}"]`);
                if (container) container.classList.add('active');

                applyEngravingTypeUI(engravingType);
                handleStepCount(currentStep + 1, 2);
            });
        });
    }

    function handleAddEngraving(selector) {
        const btn = selector.querySelector('.add-engraving-next-btn button');
        if (!btn) return;
        btn.addEventListener('click', function () {
            const currentStep = parseInt(selector.dataset.currentStep);
            selector.classList.remove('active');
            const next = document.querySelector(`[data-current-step="${currentStep + 1}"]`);
            if (next) next.classList.add('active');
            handleStepCount(currentStep + 1);
        });
    }

    function handleSelectEngravingFont(selector) {
        selector.querySelectorAll('.engraving-font-item-block').forEach(block => {
            block.addEventListener('click', function () {
                removeActiveClass('.engraving-font-item-block');
                block.classList.add('active');
                engravingFont = block.dataset.font;
            });
        });
    }

    function handleSelectStone(selector) {
        // FIX: auto-select first in each group on init
        selector.querySelectorAll(
            '.select-product-finish-wrapper, .select-product-engraving-wrapper'
        ).forEach(wrapper => {
            if (!wrapper.querySelector('.product-option-block.active')) {
                const first = wrapper.querySelector('.product-option-block');
                if (first) first.classList.add('active');
            }
        });

        // Stone toggle
        selector.querySelectorAll('.select-stone-block').forEach(block => {
            block.addEventListener('click', function () {
                removeActiveClass('.select-stone-block');
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Finish option
        selector.querySelectorAll('.select-finish-block').forEach(block => {
            block.addEventListener('click', function () {
                block.closest('.select-product-finish-wrapper')
                    .querySelectorAll('.select-finish-block')
                    .forEach(b => b.classList.remove('active'));
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Engraving-count / other option
        selector.querySelectorAll('.select-engraving-block').forEach(block => {
            block.addEventListener('click', function () {
                block.closest('.select-product-engraving-wrapper')
                    .querySelectorAll('.select-engraving-block')
                    .forEach(b => b.classList.remove('active'));
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Add to cart
        const addBtn = selector.querySelector('.select-stone-add-btn button');
        if (addBtn) {
            addBtn.addEventListener('click', handleAddToCart);
        }

        // Trigger initial variant resolution
        handleVariantChange();
    }

    // Wire up all steps
    document.querySelectorAll('.variant-popup-body-item').forEach(item => {
        const type = item.dataset.type;
        if (type === 'select-engraving-type') handleEngravingType(item);
        if (type === 'add-engraving') {
            handleAddEngraving(item);
            handleSelectEngravingFont(item);
        }
        if (type === 'select-stone') handleSelectStone(item);
    });

});